import React, { useEffect, useState } from "react";
import { Edit, SimpleForm, TextInput, SelectInput, required, TopToolbar, Button, useRedirect, DateInput, AutocompleteInput, useNotify, RadioButtonGroupInput, useGetOne, FileInput, FileField } from "react-admin";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Divider, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { cleanTimeChoices, getNameAndCompanyNamewithAddress, fetchStaffList, addStaff, deleteStaff } from "../common";
import StaffModal from "../components/StaffModal";
import { useFormContext, useWatch } from "react-hook-form";
import NoteAddIcon from '@mui/icons-material/NoteAdd';

const InspectHistoryEdit = () => {
  const redirect = useRedirect();
  const notify = useNotify();
  const { id } = useParams();
  const [customers, setCustomers] = useState([]);
  const [invoiceHistory, setInvoiceHistory] = useState([]);
  const [customerId, setCustomerId] = useState(null);
  const [contract, setContract] = useState(null);
  const [isNew, setisNew] = useState(-1);
  const [isPay, setIsPay] = useState(0);
  const [invoiceId, setInvoiceId] = useState(null);
  const [showInvoice, setShowInvoice] = useState(false);
  const { data, isLoading } = useGetOne("inspectHistory", { id });

  useEffect(() => {
    if (!isLoading) {
      fetchUser();
      setCustomerId(data.customerId);
      setInvoiceId(data.invoiceId);
    }
  }, [isLoading])

  const fetchUser = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/inspect`, {
        method: "GET",
        headers: new Headers({ "Content-Type": "application/json" }),
        mode: "cors",
        credentials: "include",
      });
      if (!response.ok) {
        throw new Error("Failed to fetch user info");
      }
      const { data } = await response.json();
      setCustomers(data);
    } catch (error) {
      console.error("ユーザー情報の取得に失敗しました:", error);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/invoiceHistory/customer/${customerId}`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setInvoiceHistory(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };
    const fetchContractInfo = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/contract/${customerId}`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setContract(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    if (customerId) {
      fetchInvoice();
      fetchContractInfo();
    }
  }, [customerId])

  const CustomTopToolbar = () => (
    <Box sx={{ padding: 0, marginBottom: -2 }}>
      <TopToolbar>
        <Button
          label="請求書を作成"
          onClick={() => redirect(`/invoice-form/inspectHistory/${id}`)}
          startIcon={<NoteAddIcon />}
        />
        <Button
          label="点検情報表示"
          onClick={() => redirect(`/inspectHistory/show/${id}`)}
          startIcon={<VisibilityIcon />}
        />
      </TopToolbar>
    </Box>
  );

  // 担当者一覧管理
  const [staffList, setStaffList] = useState([]);
  const [openStaffModal, setOpenStaffModal] = useState(false);
  const [newStaffName, setNewStaffName] = useState("");

  useEffect(() => {
    fetchStaffList().then(setStaffList);
  }, [openStaffModal]);

  const handleAddStaff = async () => {
    if (!newStaffName.trim()) return;
    await addStaff(newStaffName);
    setNewStaffName("");
    setOpenStaffModal(false);
  };

  const handleDeleteStaff = async (dbId) => {
    await deleteStaff(dbId);
    setOpenStaffModal(false);
  };

  return (
    <>
      <CustomTopToolbar />
      <Edit mutationMode="pessimistic"
        mutationOptions={{
          onSuccess: () => {
            notify('更新が完了しました', { type: 'success' });
            // redirect('list', 'inspectHistory');
            window.history.back();
          }
        }}
      >
        <SimpleForm
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
          }}
        >
          <InspectFormSection
            data={data}
            customers={customers}
            customerId={customerId}
            setCustomerId={setCustomerId}
            setShowInvoice={setShowInvoice}
            staffList={staffList}
            setOpenStaffModal={setOpenStaffModal}
          />
          <StaffModal
            open={openStaffModal}
            staffList={staffList}
            newStaffName={newStaffName}
            setNewStaffName={setNewStaffName}
            handleAddStaff={handleAddStaff}
            handleDeleteStaff={handleDeleteStaff}
            onClose={() => setOpenStaffModal(false)}
          />
          {showInvoice && (
            <InvoiceFormSection contract={contract} isPay={isPay} setIsPay={setIsPay} />
          )}
          {/* </>
            ) : (
              <AutocompleteInput
                source="invoiceId"
                label="請求履歴"
                choices={invoiceHistory.map(req => ({
                  id: req.invoiceId, 
                  name: `請求No.${String(req.id).padStart(5, "0")}（請求日：${(new Date(req.invoiceDate)).toLocaleDateString('ja-JP')}）`
                }))}
                disabled={!customerId}
                allowEmpty
                freeSolo  
              />
            )}
            </>
            )}
            </>
          )} */}
        </SimpleForm>
      </Edit>
    </>
  )

};

const InspectFormSection = ({ data, customers, customerId, setCustomerId, setShowInvoice, staffList, setOpenStaffModal }) => {
  // フォームの点検日を監視し、月が一致するか判定
  const form = useFormContext();
  const inspectDate = useWatch({ name: 'inspectDate' }, form.control) || undefined;

  useEffect(() => {
    if (!customerId || !inspectDate) {
      setShowInvoice(false);
      return;
    }
    // inspectDateから月を取得
    const dateObj = new Date(inspectDate);

    const invoiceMonth = customers.find(cust => cust.id === customerId)?.invoiceMonth;
    if (!invoiceMonth) {
      setShowInvoice(false);
      return;
    }

    const inspectMonth = (dateObj.getMonth() + 1);

    setShowInvoice(invoiceMonth == inspectMonth);
  }, [inspectDate, customerId, customers]);


  return (
    <>
      <AutocompleteInput
        source="customerId"
        label="顧客名"
        choices={customers.map(req => ({
          id: req.id,
          name: `${getNameAndCompanyNamewithAddress(req)}`
        }))}
        onChange={(e) => setCustomerId(e)}
        validate={required()}
        allowEmpty
        freeSolo
      />
      {/* <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}> */}
      <DateInput source="inspectDate" label="点検日" inputProps={{ max: '9999-12-31' }} />
      {/* <DateInput source="exCleaningDate" label="清掃予定日" style={{marginLeft:"10px",marginRight:"10px"}}/>
      <SelectInput 
        source="exCleaningTime"
        label="清掃予定時間"
        choices={cleanTimeChoices}
        style={{marginLeft:"10px"}}
      />
    </div>          */}

      <TextInput source="content" label="点検内容" multiline rows={5} />
      <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
        <RadioButtonGroupInput
          source="needsCleaning"
          label="清掃が必要かどうか"
          choices={[
            { id: 1, name: '清掃必要' },
            { id: 0, name: '清掃不要' }
          ]}
          style={{ marginRight: "20px" }}
        />
        <RadioButtonGroupInput
          source="isSampling"
          label="採水かどうか"
          choices={[
            { id: 1, name: '採水あり' },
            { id: 0, name: '採水なし' }
          ]}
          style={{ marginLeft: "20px" }}
        />
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
        <div style={{ flex: 2, marginRight: "10px" }}>
          <SelectInput source="staffName" label="担当者名" choices={staffList} />
        </div>
        <button type="button" style={{ flex: 1, margin: "auto 0", marginLeft: "10px" }} onClick={() => setOpenStaffModal(true)} >担当者一覧</button>
      </div>
    </>
  );
};

const InvoiceFormSection = ({ contract, isPay, setIsPay }) => {

  return (
    <>
      <Divider sx={{ my: 2 }} /> {/* セクション区切り */}
      <Typography variant="h6">請求情報</Typography>
      {/* {isNew === 1 ? (
          <> */}
      <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
        <input type="hidden" name="invoiceId" />
        <DateInput source="invoiceDate" label="請求日" style={{ marginRight: "10px" }} inputProps={{ max: '9999-12-31' }} />
        <TextInput source="invoiceAmount" label="請求金額(税抜き)" style={{ marginLeft: "10px", marginRight: "10px" }} defaultValue={contract && contract.contractAmount && contract.contractAmount.toLocaleString()} />
        <SelectInput source="payMethod" label="支払い方法" choices={[
          { id: "持参", name: "持参" },
          { id: "振り込み", name: "振り込み" },
          { id: "集金", name: "集金" }
        ]} style={{ marginLeft: "10px" }} />
      </div>
      <DateInput source="reissueDate" label="再発行日" inputProps={{ max: '9999-12-31' }} />
      <RadioButtonGroupInput
        source="isPay"
        label="領収"
        choices={[
          { id: 1, name: '領収済み' },
          { id: 0, name: '未領収' }
        ]}
        defaultValue={isPay}
        validate={required()}
        onChange={(e) => setIsPay(Number(e.target.value))}
      />
      <DateInput source="receiptDate" label="領収日" disabled={!isPay} inputProps={{ max: '9999-12-31' }} />
      <FileInput source="documentURL" label="請求書" accept="application/pdf, image/*">
        <FileField source="src" title="title" />
      </FileInput>
    </>
  );
};

export default InspectHistoryEdit;
